import axios from 'axios'
// import { getToken } from '@/utils/auth'
import { Notify } from 'vant'
import router from '@/router/index'

// 创建axios实例
const service = axios.create({
  // eslint-disable-next-line
  baseURL: _API_, // api 的 base_url
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    'Guitu-Auth-Type': 'GuituAppShareWeb'
  }
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 设置请求头
    // config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200时抛错 可结合自己业务进行修改
     */
    if (response.data.code !== 1) {
      // console.log('response', response)
      if (typeof response.data === 'string') {
        Notify({ type: 'danger', message: response.data })
      } else {
        // 稿件下线
        if (response.data.code === 20002) {
          router.push('/updown')
          return false
        }
        Notify({ type: 'danger', message: response.data.message || '接口异常，请稍后重试' })
      }
      return Promise.reject(response.data)
    } else {
      return response.data
    }
  },
  error => {
    if (error.response && error.response.status === 401) {
      Notify({ type: 'danger', message: '登录超时，请重新登录' })
    } else {
      Notify({ type: 'danger', message: error.message || '接口异常，请稍后重试' })
    }
    return Promise.reject(error)
  }
)

export default service
